import { render } from "./NewMessagePanel.vue?vue&type=template&id=210634fc&scoped=true"
import script from "./NewMessagePanel.vue?vue&type=script&lang=js"
export * from "./NewMessagePanel.vue?vue&type=script&lang=js"

import "./NewMessagePanel.vue?vue&type=style&index=0&id=210634fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210634fc"]])

export default __exports__